<template>
  <div class="mainContent">
    <Header/>
    <keep-alive>
      <router-view v-if="$route.meta.keepAlive" />
    </keep-alive>
    <router-view v-if="!$route.meta.keepAlive" />
    <Footer/>
  </div>
</template>
<script>
import Header from "@/component/header";
import Footer from "@/component/footer";
export default {
  components: {
    Header,
    Footer
  },
  data: function () {
    return { };
  },
  created: function () {},
  methods: {},
  mounted() {
    // var map = new BMap.Map("container");
    // var point = new BMap.Point(116.404, 39.915);
  },
};
</script>
<style lang="less">
  .mainContent{
    background: #EBEBEB;
  }
</style>